import { defineMessage } from 'services/localization';

export const messages = {
    headerText: defineMessage('netsuite_data_synchronisation_status'),
    syncAll: defineMessage('sync_all'),
    fieldCol: defineMessage('field'),
    lastSyncCol: defineMessage('last_successful_sync'),
    lastSyncErrorCol: defineMessage('error_on_last_sync'),
};
